var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 11 11"}},[_c('path',{attrs:{"fill":"currentColor","d":"M10.845 6.87H6.659v3.857V6.87H.541V5.053h4.186V.659v4.394h6.118z"}})])
}
var staticRenderFns = []

export default { render: render }